<template>
    <div v-if="show" :class="['login-body lie', IsMobile ? '' : 'pc-login-body']">
        <div class="login-content lie">
            <img class="my-icon" :src="require('@/assets/logo.png')" />
            <div class="content lie" v-if="active == 'login'">
                <var-input class="input" v-model="userName" :placeholder="$t('components.LoginComponent.emailorphone')">
                    <template #prepend-icon>
                        <var-icon name="shouji" namespace="icon" />
                    </template>
                </var-input>
                <var-input class="input" type="password" v-model="password"
                    :placeholder="$t('components.LoginComponent.qsrmm')">
                    <template #prepend-icon>
                        <var-icon name="mima" namespace="icon" />
                    </template>
                </var-input>
                <VarButton class="login-button" type="primary" @click="ToLogin">
                    {{ $t('components.LoginComponent.login') }}</VarButton>
                <div class="register-box row">
                    <var-link type="primary" underline="none" @click="ShowRegister">{{
                        $t('components.LoginComponent.register')
                    }}</var-link>
                    <var-link type="primary" underline="none" @click="ShowForgotPassword">{{
                        $t('components.LoginComponent.wjmm')
                        }}</var-link>
                </div>
            </div>
            <div class="content lie" v-else-if="active == 'register'">
                <!-- <var-input class="input" v-model="userName" placeholder="邮箱/手机号码">
                    <template #prepend-icon>
                        <var-icon name="shouji" namespace="icon" />
                    </template>
                </var-input> -->
                <var-input v-model="registerObj.Email" class="input" type="email"
                    :placeholder="$t('components.LoginComponent.dzyj')">
                    <template #prepend-icon>
                        <var-icon name="youxiang" namespace="icon" />
                    </template>
                </var-input>
                <var-input class="input" type="text" v-model="registerObj.EmailCode"
                    :placeholder="$t('components.LoginComponent.email_code')">
                    <template #prepend-icon>
                        <var-icon name="yanzhengyanzhengma" namespace="icon" />
                    </template>
                    <template #append-icon>
                        <VarButton v-if="TimeDown > 0" type="default">{{ TimeDown }}s
                        </VarButton>
                        <VarButton v-else-if="TimeDown == -1">
                            <VarLoading></VarLoading>
                        </VarButton>
                        <VarButton v-else @click="SendEmailCode(registerObj.Email)" type="primary">
                            {{ $t('components.LoginComponent.fasong') }}</VarButton>
                    </template>
                </var-input>

                <var-input class="input" type="tel" v-model="registerObj.Phone"
                    :placeholder="$t('components.LoginComponent.phone')">
                    <template #prepend-icon>
                        <var-icon name="shouji" namespace="icon" />
                    </template>
                </var-input>

                <var-input class="input" type="password" v-model="registerObj.Password"
                    :placeholder="$t('components.LoginComponent.dlmm')">
                    <template #prepend-icon>
                        <var-icon name="mima" namespace="icon" />
                    </template>
                </var-input>

                <var-input class="input" type="text" v-model="registerObj.ParentAccountUid"
                    :placeholder="$t('components.LoginComponent.yqm')">
                    <template #prepend-icon>
                        <var-icon name="mima" namespace="icon" />
                    </template>
                </var-input>


                <VarButton class="login-button" type="primary" @click="ToRegisterAsync">
                    {{ $t('components.LoginComponent.ljzc') }}
                </VarButton>
                <div class="register-box row" style="justify-content: center;">
                    <var-link type="primary" underline="none" class="hui-color">{{ $t('components.LoginComponent.yyzh')
                        }}</var-link>
                </div>
                <div class="register-box row" style="justify-content: center;">
                    <var-link type="primary" underline="none" @click="ShowLogin(true)">{{
                        $t('components.LoginComponent.qudenglu')
                    }}</var-link>
                </div>
            </div>
            <div class="content lie" v-else-if="active == 'forgotPassword'">
                <var-input class="input" type="email" v-model="resetPasswordObj.Email"
                    :placeholder="$t('components.LoginComponent.dzyj')">
                    <template #prepend-icon>
                        <var-icon name="youxiang" namespace="icon" />
                    </template>
                </var-input>
                <var-input class="input" type="text" v-model="resetPasswordObj.EmailCode"
                    :placeholder="$t('components.LoginComponent.email_code')">
                    <template #prepend-icon>
                        <var-icon name="yanzhengyanzhengma" namespace="icon" />
                    </template>
                    <template #append-icon>
                        <VarButton v-if="TimeDown > 0" type="default">{{ TimeDown }}s
                        </VarButton>
                        <VarButton v-else @click="SendEmailCode(resetPasswordObj.Email)" type="primary">
                            {{ $t('components.LoginComponent.fasong') }}
                        </VarButton>
                    </template>
                </var-input>
                <var-input class="input" type="password" v-model="resetPasswordObj.Password"
                    :placeholder="$t('components.LoginComponent.dlmm')">
                    <template #prepend-icon>
                        <var-icon name="mima" namespace="icon" />
                    </template>
                </var-input>
                <var-input class="input" type="password" v-model="resetPasswordObj.ResetPassword"
                    :placeholder="$t('components.LoginComponent.qrmm')">
                    <template #prepend-icon>
                        <var-icon name="zhongfumima" namespace="icon" />
                    </template>
                </var-input>
                <VarButton class="login-button" type="primary" @click="ResetPassword">
                    {{ $t('components.LoginComponent.queren') }}
                </VarButton>
                <div class="register-box row">
                    <var-link type="primary" underline="none" class="hui-color">{{ $t('components.LoginComponent.yyzh')
                        }}</var-link>
                    <var-link type="primary" underline="none" @click="ShowLogin(true)">{{
                        $t('components.LoginComponent.qudenglu')
                    }}</var-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useLocale } from '@/hooks/useLocale';
import { useUserStore } from '@/store/UserStore';
import { fetchResetPassword, InputRegister, InputResetPassword } from '@/typescript/Services/Api/AuthApi';
import { SendEmailCodeAsync } from '@/typescript/Services/Api/EmailApi';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';
type InputType = "login" | "register" | "forgotPassword";
const active = ref<InputType>("login");
const TimeDown = ref<number>(0);
const userStore = useUserStore();
const local = useLocale();
const IsMobile = inject<boolean>("IsMobile");
const registerObj = ref<InputRegister>({
    Email: "",
    EmailCode: "",
    Password: "",
    ParentAccountUid: "",
    Phone: ""
});

const resetPasswordObj = ref<InputResetPassword & {
    ResetPassword: string
}>({
    Email: "",
    EmailCode: "",
    Password: "",
    ResetPassword: ""
});

const userName = ref('');
const password = ref('');
const show = ref(false);

watch(active, (_n, _o) => {
    switch (_n) {
        case "register":
            const EXCHANGE_SHARE_UID = Tools.GetLocalStorage('EXCHANGE_SHARE_UID', "");
            registerObj.value.ParentAccountUid = EXCHANGE_SHARE_UID;
            break;
    }
});

/**
 * 显示登录框
 */
function Show() {
    userName.value = '';
    password.value = '';
    show.value = true;
}
/**
 * 关闭登录框
 */
function Close() {
    show.value = false;
}

/**
 * 显示注册
 */
function ShowRegister() {
    active.value = "register";
    Show();
}

/**
 * 显示忘记密码
 */
function ShowForgotPassword() {
    active.value = "forgotPassword";
    Show();
}

/**
 * 显示登录框
 */
function ShowLogin(flag: boolean = false) {
    if (!flag)
        if (show.value)
            return;
    active.value = "login";
    Show();
}

/**
 * 去登录
 */
function ToLogin() {
    if (Tools.IsNull(userName.value)) {
        Tools.AlertError(local.t('components.LoginComponent.sjhbnwk'));
        return;
    }
    if (Tools.IsNull(password.value)) {
        Tools.AlertError(local.t('components.LoginComponent.mmbnwk'));
        return;
    }

    Global.ToLoginAsync({
        userName: userName.value,
        password: password.value
    }).then(flag => {
        if (flag) {
            Close();
            userStore.UpdateUserDataAsync();
        }
    })
}



/**
 * 发送邮件验证码
 */
function SendEmailCode(email: string) {
    if (Tools.IsNull(email)) {
        Tools.AlertError(local.t('components.LoginComponent.qsryx'));
        return;
    }
    TimeDown.value = -1;
    SendEmailCodeAsync(email).then(resp => {
        if (resp.CheckIsOk()) {
            TimeDown.value = 60;
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.LoginComponent.yzmyfs'));
        }
    });
}

/**
 * 开始倒计时
 */
function StartTimeDown() {
    let timeDown = TimeDown.value;
    if (timeDown > 0) {
        TimeDown.value--;
        if (TimeDown.value <= 0)
            TimeDown.value = 0;
        setTimeout(StartTimeDown, 1000);
    }
}


/**
 * 注册账号
 */
async function ToRegisterAsync() {
    if (await Global.RegisterAsync(registerObj.value)) {
        Close();
        userStore.UpdateUserDataAsync();
    }
}

/**
 * 重置密码
 */
function ResetPassword() {
    fetchResetPassword(resetPasswordObj.value).then(resp => {
        if (resp.CheckIsOk()) {
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.LoginComponent.czmmcg'));
        }
    });
}



defineExpose({
    ShowLogin
})

</script>

<style scoped lang="scss">
.pc-login-body {
    width: 100% !important;
    height: 100% !important;

    .login-content {
        width: 65%;
        max-width: 450px;
        min-width: 30%;
        height: 50%;
    }
}

.login-body {
    justify-content: center;
    align-items: center;
    background-color: var(--color-surface-container-highest);
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2003;

    .login-content {
        width: 85%;
        max-width: 450px;
        min-width: 30%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .my-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            min-width: 80px;
            min-height: 80px;
        }

        .content {
            width: 100%;
            justify-content: center;
            align-items: center;
        }

        .input {
            width: 80%;
        }

        .login-button {
            margin-top: 20px;
            width: 80%;
        }

        .register-box {
            margin-top: 20px;
            justify-content: space-between;
            width: 50%;
        }
    }
}
</style>